import { Box } from '@chakra-ui/react';
import { Text } from '../../typography';

export interface TextVariantProps {
    label: string;
    value?: string;
}

export const TextVariant = ({ label, value }: TextVariantProps) => (
    <Box display="flex" className="space-x-1">
        <Text style="bold">{label}</Text>
        <Text textTransform="capitalize">{value}</Text>
    </Box>
);
